import qs from 'qs'
import React, { useMemo } from 'react'
import { getImage } from '../../components/helpers/FormatLinks'
import Page from '../../components/page/Page'
import AnalyticsComponent from '../../components/stats/AnalyticsComponent'
import Chart from '../../components/stats/Chart'
import CollectionComponent from '../../components/stats/CollectionComponent'
import TopCollections from '../../components/stats/TopCollections'
import TopMarkets from '../../components/stats/TopMarkets'
import { UsersTable } from '../../components/stats/userstable/UsersTable'
import config from '../../config.json'
import { useLanguage, useQueryString } from '../../hooks'

const QUICK_STATS = 'quick_stats'
const HISTORY = 'history'
const COLLECTION_VOLUME = 'collection_volume'
const TOP_COLLECTIONS = 'top_collections'
const TOP_MARKETS = 'top_markets'
const TOP_TRADERS = 'top_traders'

// define the analytics components structure ahead of the component to not calculate them every time
const AnalyticsComponents = [
    [HISTORY, 'analytics.history', Chart],
    [COLLECTION_VOLUME, 'analytics.collection_volume', CollectionComponent],
    [TOP_COLLECTIONS, 'analytics.top_collections', TopCollections],
    [TOP_MARKETS, 'analytics.top_markets', TopMarkets],
    [TOP_TRADERS, 'analytics.top_traders', UsersTable],
]

const AnalyticsPage = (props) => {
    const { t } = useLanguage(props)
    const { getValue } = useQueryString()

    let values =
        typeof window !== 'undefined'
            ? qs.parse(
                  window.location.search.substring(
                      1,
                      window.location.search.length,
                  ),
              )
            : []
    const module = 'module' in values ? values['module'] : ''
    const searchAuthor = props.collection
        ? props.collection
        : getValue('collection', '*')
    const image = getImage(searchAuthor)

    // memoize the analytics components
    const analyticsComponents =
        typeof window !== 'undefined'
            ? useMemo(
                  () =>
                      AnalyticsComponents
                          // filter out the analytics components that are not needed
                          .filter(
                              ([moduleName]) =>
                                  !module || moduleName === module,
                          )
                          // map the analytics components to the components
                          .map(([, title, Component]) => (
                              <div className="w-full px-2 lg:px-8">
                                  <AnalyticsComponent title={t(title)}>
                                      <Component
                                          searchAuthor={searchAuthor}
                                          {...props}
                                      />
                                  </AnalyticsComponent>
                              </div>
                          )),
                  [searchAuthor, props, t],
              )
            : ''

    return (
        <Page
            id={'StatsPage'}
            title={config.titles.analytics}
            description={config.descriptions.analytics}
            image={image}
            {...props}
            pageTitle={t('pages.dive_into_analytics')}
            pageSubtitle={t('pages.explore_statistics')}
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Stats',
                    link: '/stats',
                },
            ]}
        >
            <div className="overflow-y-auto">{analyticsComponents}</div>
        </Page>
    )
}

AnalyticsPage.getInitialProps = async (ctx) => {
    const paths = ctx.asPath.split('/')

    return qs.parse(paths[paths.length - 1].replace('stats?', ''))
}

export default AnalyticsPage
